import classNames from 'classnames';
import { BUTTON_TEXT_CLASS_NAME, FOCUS_CLASS_NAME } from './styles';

interface ISegmentedControlProps<T> {
  label: string;
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

export default function SegmentedControl<T extends string | number>({
  label,
  options,
  value,
  onChange,
}: ISegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className="flex rounded-[12px] bg-control p-[3px]"
    >
      {options.map((option) => {
        const isSelected = option.value === value;
        return (
          <button
            key={option.value}
            role="radio"
            aria-checked={isSelected}
            onClick={() => onChange(option.value)}
            className={classNames(
              'h-[34px] min-w-0 flex-1 rounded-[10px] text-[13px] font-semibold transition-colors duration-150',
              isSelected
                ? 'bg-surface text-ink shadow-seat-card'
                : 'bg-transparent text-ink-muted',
              FOCUS_CLASS_NAME
            )}
          >
            <span className={BUTTON_TEXT_CLASS_NAME}>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
